<dw-router-parent>
  <ng-template>
    <app-report-dashboard
      [definition]="definition"
      [expressionContext]="expressionContext">
    </app-report-dashboard>
  </ng-template>
</dw-router-parent>

